import * as React from 'react';

import {Button} from '../button/button';
import {CloseButton} from '../button/close-button/close-button';
import {SaveButton} from '../button/save-button/save-button';
import type {ButtonVariant} from '../button/types';
import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';
import {Title} from '../typography/title';

import styles from './popover-form.module.css';

type Props = {
    children: React.ReactNode;
    width: number;
    height?: number;
    title: React.ReactNode;
    subTitle?: string;
    onClose: () => void;
    onSubmit: () => void;
    saveButtonDisabled: boolean;
    saveButtonDisabledTooltip?: string;
    isSaving: boolean;
    errorSaving?: boolean;
    onClearSaveComplete?: () => void;
    saveButtonText?: string;
    saveButtonSavingText?: string;
    saveButtonSuccessText?: string;
    shouldHideCloseButton?: boolean;
    cancelButtonText: string;
    allowTitleWrapping?: boolean;
    resetOnSaveComplete?: boolean;
    saveCompleteTimeout?: number;
    hideSubmitButton?: boolean;
    formBodyStyles?: any;
    saveButtonVariant?: ButtonVariant;
};

PopoverForm.defaultProps = {
    width: 300,
    isSaving: false,
    saveButtonDisabled: false,
    cancelButtonText: 'Cancel',
};

export function PopoverForm(props: Props) {
    const onSubmit = (e: React.FocusEvent<any>) => {
        e.preventDefault();
        props.onSubmit();
    };

    return (
        <div style={{width: props.width, height: props.height}} className={styles['popover-form']}>
            <div className={styles.top}>
                <Stack spacing={props.subTitle ? 8 : 0}>
                    <div
                        className={
                            props.allowTitleWrapping ? styles.title : styles['title--no-wrap']
                        }
                    >
                        <Title>{props.title}</Title>
                    </div>
                    {props.subTitle && <Body wrapAnywhere={true}>{props.subTitle}</Body>}
                </Stack>
                {props.shouldHideCloseButton ? undefined : <CloseButton onClick={props.onClose} />}
            </div>
            <form onSubmit={onSubmit}>
                <div style={props.formBodyStyles} className={styles['form-body']}>
                    {props.children}
                </div>
                <div className={styles.buttons}>
                    <Button variant='text' onClick={props.onClose} size='big'>
                        {props.cancelButtonText}
                    </Button>
                    {props.hideSubmitButton ? undefined : (
                        <SaveButton
                            isSaving={props.isSaving}
                            buttonText={props.saveButtonText}
                            disabled={props.saveButtonDisabled}
                            savingText={props.saveButtonSavingText}
                            successText={props.saveButtonSuccessText}
                            onClearSaveComplete={props.onClearSaveComplete}
                            errorSaving={props.errorSaving}
                            resetOnComplete={props.resetOnSaveComplete}
                            saveCompleteTimeout={props.saveCompleteTimeout}
                            variant={props.saveButtonVariant}
                            disabledTooltip={props.saveButtonDisabledTooltip}
                        />
                    )}
                </div>
            </form>
        </div>
    );
}
